import { crv, cva } from '@/styled-system/css';

export const dividerRecipe = cva({
  variants: {
    tone: {
      'muted': {
        backgroundColor: 'Divider.muted.bg',
      },
      'muted-alt': {
        backgroundColor: 'Divider.muted-alt.bg',
      },
      'emphasized': {
        backgroundColor: 'Divider.emphasized.bg',
        marginInline: 'auto',
      },
    },
    ...crv('orientation', {
      horizontal: {
        height: 'Divider.weight.horizontal',
        width: 'Divider.width.horizontal',
      },
      vertical: {
        height: 'Divider.height.vertical',
        width: 'Divider.weight.vertical',
      },
    }),
  },
  compoundVariants: [
    {
      orientation: 'horizontal',
      tone: 'emphasized',
      css: {
        width: 'Divider.width.emphasized',
        height: 'Divider.weight.emphasized.horizontal',
      },
    },
  ],
});
